export default {"src":"/_next/static/media/icon-pin-jula.70740de7.svg","height":55,"width":40,"blurWidth":0,"blurHeight":0};